
import SupplierEanUpdate    from '@/components/frontOffice/SupplierEanUpdateFromFile.vue'

const menuId = 'fo5'
const routes = [
        
    {
        path        : '/eanSupplierUpdate', 
        name        : 'importSupplierEan',
        component   : SupplierEanUpdate,
        meta        : { name : 'Associazione EAN fornitore da file', visible : true ,icon : 'fas fa-file-export',menu:menuId,color:'green'},   
    },
    
]
export default routes
